<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Exam Results Send</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <upload-exam-result v-if="pagepermission.insertable" @created="handleCreated" />
        </div>
      </div>
    </div>
    <div v-if="pagepermission.viewable">
      <div class="row">
        <div class="col-md-6 col-12 mb-2">
          <a-input-search
            placeholder="Search student code, mobile no. ..."
            size="large"
            v-model="search"
            @search="searchNotificationMessage"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <exam-result-send-table :data="data" :loading="loading" @updateTable="handleUpdateTable"/>
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ExamResultSendTable from '@/components/examResultSendNotify/Table/index'
import UploadExamResult from '@/components/examResultSendNotify/Forms/index'

export default {
  components: {
    ExamResultSendTable,
    UploadExamResult,
  },
  beforeMount: function() {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('notification', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.getSchoolNotifications()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      search: null,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  methods: {
    getSchoolNotifications: function() {
      this.loading = true
      this.$http.get('/api/notifications/individual/all', {
        params: {
          limit: this.pageSize,
          page: this.current,
          search: this.search,
          type: 'sendresult',
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchNotificationMessage: function(value) {
      this.search = value
      this.getSchoolNotifications(true)
    },
    handleCreated: function() {
      this.getSchoolNotifications()
    },
    handleUpdateTable: function() {
      this.getSchoolNotifications()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getSchoolNotifications()
    },
    onChange(current) {
      this.current = current
      this.getSchoolNotifications()
    },
  },
}
</script>
